import {
  createConfiguration,
  type Middleware as ApiGatewayMiddleware,
} from '@repo/api-gw-sdk';
import {
  createConfiguration as createLakehouseConfiguration,
  type Middleware as LakehouseMiddleware,
} from '@repo/lakehouse-sdk';

export const createConfig = (
  baseUrl: string,
  authToken: string | undefined,
  middleware?: ApiGatewayMiddleware[]
) =>
  createConfiguration({
    baseUrl,
    ...(middleware ? { middleware } : {}),
    ...(authToken
      ? {
          authMethods: {
            ApiKeyAuth: `Bearer ${authToken}`,
          },
        }
      : {}),
    timeout: 2 * 60_000, // 2 minutes default timeout, can be overridden per request
    retries: 5, // Retry idempotent request 5 times
  });

export const createLakehouseConfig = (
  baseUrl: string,
  authToken: string | undefined,
  middleware?: LakehouseMiddleware[]
) =>
  createLakehouseConfiguration({
    baseUrl,
    ...(middleware ? { middleware } : {}),
    ...(authToken
      ? {
          authMethods: {
            ApiKeyAuth: `Bearer ${authToken}`,
          },
        }
      : {}),
    timeout: 2 * 60_000, // 2 minutes default timeout, can be overridden per request
    retries: 5, // Retry idempotent request 5 times
  });
